import React from "react";
import {Route} from "react-router-dom";
import DailyLoansReport from "../../pages/reports/dailyLoans";
import ActiveGuaranteesDetail from "../../pages/reports/activeGuaranteesDetail"
import ActiveGuaranteesDetailWithLoanInFlow from "../../pages/reports/activeGuaranteesDetailWithLoanInFlow"
import HistoricalReport from "../../pages/reports/historical";
import SendConfirmation from "../../pages/reports/historical/sendConfirmation";
import ActiveLoans from "../../pages/reports/activeLoans";
import ConcentratedPosition from "../../pages/reports/concentratedPosition";
import ActiveMarketLoans from "../../pages/reports/activeMarketLoans";
import DoneLoans from "../../pages/reports/doneLoans";
import ActiveDailyLoans from "../../pages/reports/activeDailyLoans";
import Aforo from "../../pages/aforo";
import EventsReport from "../../pages/reports/events";
import IntraInstitutionalReport from "../../pages/reports/intraInstitutional";
import AladdinReport from "../../pages/process";

import {
    ACTIVE_DAILY_LOANS_REPORT_ROUTE,
    ACTIVE_GUARANTEES_DETAIL_REPORT_ROUTE,
    ACTIVE_GUARANTEES_DETAIL_WITH_LOAN_IN_FLOW_REPORT_ROUTE,
    ACTIVE_LOANS_REPORT_ROUTE,
    ACTIVE_MARKET_LOANS_REPORT_ROUTE,
    CONCENTRATED_POSITION_REPORT_ROUTE,
    CONSULT_AFORO_ROUTE,
    DAILY_LOANS_REPORT_ROUTE,
    DONE_LOANS_REPORT_ROUTE,
    HISTORICAL_REPORT_ROUTE,
    SEND_CONFIRMATION_REPORT_ROUTE,
    EVENTS_REPORT_ROUTE,
    INTRA_INSTITUTIONAL_REPORT_ROUTE,
    ALADDIN_REPORT_ROUTE
} from "../../utils/constants/RoutesConstants";

const ReportsRoutes = () => {
    return (
        <React.Fragment>
            <Route path={DAILY_LOANS_REPORT_ROUTE} component={DailyLoansReport}/>
            <Route path={ACTIVE_GUARANTEES_DETAIL_REPORT_ROUTE} component={ActiveGuaranteesDetail}/>
            <Route path={HISTORICAL_REPORT_ROUTE} component={HistoricalReport}/>
            <Route path={SEND_CONFIRMATION_REPORT_ROUTE} component={SendConfirmation}/>
            <Route path={ACTIVE_LOANS_REPORT_ROUTE} component={ActiveLoans}/>
            <Route path={CONCENTRATED_POSITION_REPORT_ROUTE} component={ConcentratedPosition}/>
            <Route path={ACTIVE_MARKET_LOANS_REPORT_ROUTE} component={ActiveMarketLoans}/>
            <Route path={DONE_LOANS_REPORT_ROUTE} component={DoneLoans}/>
            <Route path={ACTIVE_DAILY_LOANS_REPORT_ROUTE} component={ActiveDailyLoans}/>
            <Route path={CONSULT_AFORO_ROUTE} render={(props) => <Aforo {...props} isReport={true}/>}/>
            <Route path={ACTIVE_GUARANTEES_DETAIL_WITH_LOAN_IN_FLOW_REPORT_ROUTE}
                   component={ActiveGuaranteesDetailWithLoanInFlow}/>
            <Route path={EVENTS_REPORT_ROUTE} component={EventsReport}/>
            <Route path={INTRA_INSTITUTIONAL_REPORT_ROUTE} component={IntraInstitutionalReport}/>
            <Route path={ALADDIN_REPORT_ROUTE} component={AladdinReport}/>

        </React.Fragment>
    );
};

export default ReportsRoutes;